import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { PageLayout } from "@/components/pagelay";
import { getHead, getServerSideProps } from "@/utils/useHead";
import styles from "./index.module.scss";

import HTMLFlipBook from "react-pageflip";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import useRequest from "@/utils/useRequest";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";

interface IProps {}
export { getServerSideProps };

export default ({ navDetail }: any) => {
  const [data, setData] = useState([]);
  const [select_cate, setSelectCate] = useState(null);
  const [details, setDetails] = useState({});
  const [perView, setPerView] = useState(5);
  const [imageList, setImageList] = useState([]);
  const t = useTranslations();
  const router = useRouter();
  const request = useRequest();
  const swiperRef = useRef<any>();

  const $swiper = useSwiper();

  console.log("router");

  console.log("13123123123123");

  // t('common.title') 是多语言的方法，在locales下有对应的cn和en文件

  const getData = useCallback(async () => {
    const {
      data: {
        data: { list },
      },
    } = await request.get(`/getEventList`, {
      params: {
        category_name: navDetail.name,
      },
    });
    if (list.length) {
      const { id } = list[0];
      setData(list);
      setSelectCate(id);
      getDetails(id);
    }
  }, []);

  const getDetails = useCallback(async (event_id) => {
    const {
      data: { data },
    } = await request.get(`/getEvent`, {
      params: {
        id: event_id,
      },
    });

    const { content_cn, content_en } = data;


    if (content_cn.indexOf('<div class="meetTitle') !== -1) {
      let img_start = content_cn.indexOf("<p>");
      let img_end = content_cn.indexOf('<div class="meetTitle"');
      let img_code = content_cn.slice(img_start, img_end);
      let style_code = content_cn.slice(0, img_start);
      let editor_code = content_cn.slice(img_end);
      let view_code = style_code + editor_code;

      data.content_cn = view_code;


      const urlRegex = /https?:\/\/[^\s"'<>]+/g;
      let imgSrcs = img_code.match(urlRegex);

      setImageList(imgSrcs);
    }

    if (content_en.indexOf('<div class="meetTitle') !== -1) {
      let img_start = content_en.indexOf("<p>");
      let img_end = content_en.indexOf('<div class="meetTitle"');
      let img_code = content_en.slice(img_start, img_end);
      let style_code = content_en.slice(0, img_start);
      let editor_code = content_en.slice(img_end);
      let view_code = style_code + editor_code;

      data.content_en = view_code;


      const urlRegex = /https?:\/\/[^\s"'<>]+/g;
      let imgSrcs = img_code.match(urlRegex);

      setImageList(imgSrcs);
    }

    swiperRef.current.swiper.slideTo(0);

    setDetails(data);
  }, []);

  const selectCateItem = (cate_id) => {
    setSelectCate(cate_id);
    getDetails(cate_id);
  };

  const prev = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const next = () => {
    swiperRef.current.swiper.slideNext();
  };

  useEffect(() => {
    getData();
    if (document.documentElement.clientWidth < 888) {
      setPerView(3);
    }
  }, []);

  return (
    <PageLayout temp="page_crumb">
      <div className={styles.container}>
        {getHead(navDetail)}
        <div className={styles.tabs}>
          <div className={styles.cateBox}>
            {data.map((item) => (
              <div
                className={`${styles.cateItem} ${
                  item.id == select_cate ? styles.cateActive : ""
                }`}
                key={item.id}
                onClick={(e) => selectCateItem(item.id)}
              >
                {item[`name_${router.locale}`]}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.bodyBox}>
            <div className={styles.title}>
              <div className={styles.titleBox}>
                <img src="/image/symbol-left-dot.png" />
                <span className={styles.titleText}>{details[`name_${router.locale}`]}</span>
                <img src="/image/symbol-right-dot.png" />
              </div>
              <img src="/image/symbol.png" />
            </div>
            <div className={styles.description}>{details[`brief_${router.locale}`]}</div>
            <div className={styles.swiper}>
              <Swiper spaceBetween={14} slidesPerView={perView} ref={swiperRef}>
                {imageList.map((item) => (
                  <SwiperSlide key={item}>
                    <img className={styles.imageItem} src={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <img
                onClick={() => prev()}
                className={`${styles.btn} ${styles.left}`}
                src="/image/left-arrow.png"
              />
              <img
                onClick={() => next()}
                className={`${styles.btn} ${styles.right}`}
                src="/image/right-arrow.png"
              />
            </div>

            {/* dangerouslySetInnerHTML={{ __html: details["content_cn"] }} */}
            <div
              className={styles.editor}
              dangerouslySetInnerHTML={{
                __html: details[`content_${router.locale}`],
              }}
            >
              {/* <div className={styles.schedule}>
                <div className={styles.scheduleContent}>
                  <div
                    className={styles.scheduleItem}
                    style={{ marginBottom: "20px" }}
                  >
                    <div className={styles.scheduleTitle}>
                      工业除尘防爆应用专场 - 会议议程
                    </div>

                    <div className={styles.scroll}>
                      <div className={styles.scrollBody}>
                        <div className={styles.contentBody}>
                          <div className={styles.divide}>&nbsp;</div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              09：30-09：50
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              GB 15605-2024 粉尘爆炸泄压规范要点解读
                            </div>
                            <div className={styles.item}>
                              蒋关宇，副秘书长，总经理助理，汇乐因斯福环保安全研究院
                            </div>
                          </div>

                          <div
                            className={`${styles.itemBackground} ${styles.scheduleItem}`}
                          >
                            <div className={styles.time}>
                              09：50-10：10
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              粉尘爆炸风险评最佳实践
                            </div>
                            <div className={styles.item}>
                              Ing. Dilip Chand Arulappan（英国）,
                              防爆安全顾问，怀克集团
                            </div>
                          </div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              10：10-10：30
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              减轻可燃性粉尘爆炸引发的风险
                            </div>
                            <div className={styles.item}>
                              Ng Zhan
                              Hao（新加坡），销售总经理，斯缇福机械（苏州）有限公司
                            </div>
                          </div>

                          <div
                            className={`${styles.itemBackground} ${styles.scheduleItem}`}
                          >
                            <div className={styles.time}>
                              10：30-10：50
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>单向隔爆阀的现状</div>
                            <div className={styles.item}>
                              Felipe
                              Ong（新加坡），亚太区负责人，上海备盈倍安全系统设备有限公司
                            </div>
                          </div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              10：50-11：10
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              爆炸安全领域的国际化战略
                            </div>
                            <div className={styles.item}>
                              <div>Dr.-Ing. Johannes Lottermann（德国）</div>
                              <div className={styles.other}>
                                会长 IND EX&reg; - 工业防爆专家国际联合会
                              </div>
                            </div>
                          </div>

                          <div
                            className={`${styles.itemBackground} ${styles.scheduleItem}`}
                          >
                            <div className={styles.time}>
                              11：10-11：30
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              喷雾干燥系统爆炸抑制解决方案
                            </div>
                            <div className={styles.item}>
                              刘波，技术服务总监，IEP 贺尔碧格（上海）有限公司
                            </div>
                          </div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              11：30-11：50
                              <div className={styles.spots}>&nbsp;</div>
                            </div>
                            <div className={styles.item}>
                              过滤器及料仓爆炸防护系统
                            </div>
                            <div className={styles.item}>
                              <div>
                                Niklas Kitzh&ouml;fer
                                (德国)，粉尘防爆亚太区业务发展总监
                              </div>
                              <div className={styles.other}>
                                认必安全控制设备贸易（上海）有限公司
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.scheduleItem}>
                    <div className={styles.scheduleTitle}>IND EX&reg; 专场</div>

                    <div className={styles.scroll}>
                      <div className={styles.scrollBody}>
                        <div className={styles.contentBody}>
                          <div className={styles.divide}>&nbsp;</div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              10：50-11：10
                              <div className={styles.spots}>&nbsp;</div>
                            </div>

                            <div className={styles.item}>
                              爆炸安全领域的国际化战略
                            </div>

                            <div className={styles.item}>
                              Dr.-Ing. Johannes Lottermann（德国）会长 IND
                              EX&reg; - 工业防爆专家国际联合会
                            </div>
                          </div>

                          <div
                            className={`${styles.itemBackground} ${styles.scheduleItem}`}
                          >
                            <div className={styles.time}>
                              11：10-11：30
                              <div className={styles.spots}>&nbsp;</div>
                            </div>

                            <div className={styles.item}>
                              喷雾干燥系统爆炸抑制解决方案
                            </div>

                            <div className={styles.item}>
                              刘波，技术服务总监，IEP 贺尔碧格（上海）有限公司
                            </div>
                          </div>

                          <div className={styles.scheduleItem}>
                            <div className={styles.time}>
                              11：30-11：50
                              <div className={styles.spots}>&nbsp;</div>
                            </div>

                            <div className={styles.item}>
                              过滤器及料仓爆炸防护系统
                            </div>

                            <div className={styles.item}>
                              Niklas Kitzh&ouml;fer
                              (德国)，粉尘防爆亚太区业务发展总监，认必安全控制设备贸易（上海）有限公司
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* 

              <div className={styles.schedule}>
                <div className={styles.scheduleContent}>
                  <div className={styles.scheduleTitle}>
                    工业除尘防爆应用专场 - 会议议程
                  </div>

                  <div className={styles.scroll}>
                    <div className={styles.scrollBody}>
                      <div className={styles.contentBody}>
                        <div className={styles.divide}>&nbsp;</div>

                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            09：30-09：50
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            GB 15605-2024 粉尘爆炸泄压规范要点解读
                          </div>
                          <div className={styles.item}>
                            蒋关宇，副秘书长，总经理助理，汇乐因斯福环保安全研究院
                          </div>
                        </div>

                        <div
                          className={`${styles.itemBackground} ${styles.scheduleItem}`}
                        >
                          <div className={styles.time}>
                            09：50-10：10
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            粉尘爆炸风险评最佳实践
                          </div>
                          <div className={styles.item}>
                            Ing. Dilip Chand Arulappan（英国）,
                            防爆安全顾问，怀克集团
                          </div>
                        </div>

                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            10：10-10：30
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            减轻可燃性粉尘爆炸引发的风险
                          </div>
                          <div className={styles.item}>
                            Ng Zhan
                            Hao（新加坡），销售总经理，斯缇福机械（苏州）有限公司
                          </div>
                        </div>

                        <div
                          className={`${styles.itemBackground} ${styles.scheduleItem}`}
                        >
                          <div className={styles.time}>
                            10：30-10：50
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>单向隔爆阀的现状</div>
                          <div className={styles.item}>
                            Felipe
                            Ong（新加坡），亚太区负责人，上海备盈倍安全系统设备有限公司
                          </div>
                        </div>

                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            10：50-11：10
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            爆炸安全领域的国际化战略
                          </div>
                          <div className={styles.item}>
                            <div>Dr.-Ing. Johannes Lottermann（德国）</div>
                            <div className={styles.other}>
                              会长 IND EX&reg; - 工业防爆专家国际联合会
                            </div>
                          </div>
                        </div>

                        <div
                          className={`${styles.itemBackground} ${styles.scheduleItem}`}
                        >
                          <div className={styles.time}>
                            11：10-11：30
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            喷雾干燥系统爆炸抑制解决方案
                          </div>
                          <div className={styles.item}>
                            刘波，技术服务总监，IEP 贺尔碧格（上海）有限公司
                          </div>
                        </div>

                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            11：30-11：50
                            <div className={styles.spots}>&nbsp;</div>
                          </div>
                          <div className={styles.item}>
                            过滤器及料仓爆炸防护系统
                          </div>
                          <div className={styles.item}>
                            <div>
                              Niklas Kitzh&ouml;fer
                              (德国)，粉尘防爆亚太区业务发展总监
                            </div>
                            <div className={styles.other}>
                              认必安全控制设备贸易（上海）有限公司
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className={styles.meetTitle}>
                <img src="/image/symbol.png" />
                <span>会议议程</span>
              </div>

              <div className={styles.infoItem}>
                <span className={styles.label}>时间</span>
                <span className={styles.tag}>：</span>
                <span className={`${styles.value} ${styles.otherValue}`}>
                  {details["date_cn"]}
                </span>
              </div>
              <div className={styles.infoItem}>
                <span className={styles.label}>地点</span>
                <span className={styles.tag}>：</span>
                <span className={`${styles.value} ${styles.otherValue}`}>
                  {details["address_cn"]}
                </span>
              </div>
              <div className={styles.infoItem}>
                <span className={styles.other}>主办单位：</span>
                <span className={styles.value}>中国颗粒学会</span>
              </div>
              <div className={styles.schedule}>
                <div className={styles.scheduleContent}>
                  <div className={styles.scheduleTitle}>
                    粉体/散料输送产业降本增效专场 - 会议议程
                  </div>
                  <div className={styles.scroll}>
                    <div className={styles.scrollBody}>
                      <div className={styles.contentHeader}>
                        <div className={styles.time}>时间</div>
                        <div className={styles.item}>主题</div>
                        <div className={styles.item}>演讲人</div>
                      </div>
                      <div className={styles.middleDivide}></div>
                      <div className={styles.contentBody}>
                        <div className={styles.divide}></div>

                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            09:40-10:00
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            EDEM-CFD气力输送系统仿真分析
                          </div>
                          <div className={styles.item}>
                            宋孚杨，总经理，深圳市德颐姆科技有限公司
                          </div>
                        </div>
                        <div
                          className={`${styles.scheduleItem} ${styles.itemBackground}`}
                        >
                          <div className={styles.time}>
                            10:00-10:30
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            化工湿法在线智能化配料系统
                          </div>
                          <div className={styles.item}>
                            涂国营，技术总监，安徽陆达智能科技股份有限公司
                          </div>
                        </div>
                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            09:40-10:00
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            当效率遇上期待：欧洲化妆品制造商如何应对物料处理与市场需求
                          </div>
                          <div className={styles.item}>
                            Miriam Hempel，联合创始人，NELE Kosmetik GmbH
                          </div>
                        </div>
                        <div
                          className={`${styles.scheduleItem} ${styles.itemBackground}`}
                        >
                          <div className={styles.time}>
                            09:40-10:30
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            在线测量技术在粉体行业的应用
                          </div>
                          <div className={styles.item}>
                            <div>
                              隆书皓，仪器仪表产品经理兼分析仪表业务中心经理
                            </div>
                            <div className={styles.other}>
                              珠海市长陆工业自动控制系统股份有限公司
                            </div>
                          </div>
                        </div>
                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            09:40-10:00
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            粉体配料系统气力输送的运用
                          </div>
                          <div className={styles.item}>
                            李天亮，总经理，上海幽威粉体设备有限公司
                          </div>
                        </div>
                        <div
                          className={`${styles.scheduleItem} ${styles.itemBackground}`}
                        >
                          <div className={styles.time}>
                            10:00-10:30
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}></div>
                          <div className={styles.item}>
                            康柏斯粉粒体工程公司（待确定）
                          </div>
                        </div>
                        <div className={styles.scheduleItem}>
                          <div className={styles.time}>
                            09:40-10:00
                            <div className={styles.spots}></div>
                          </div>
                          <div className={styles.item}>
                            固体散装物料输送监测的综合解决方案
                          </div>
                          <div className={styles.item}>
                            牟锐，产品经理，恩威雅环境技术（北京）有限公司
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
